export function getMissions(query) {
    return axios({
        url: '/api/missions',
        method: 'get',
        params: query,
    });
}
